import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { VersionCheck } from "interfaces/version-check";
import axios from "axios";
import { siteSettings } from "core/siteSettings";

export const useVersionCheckQuery = (): UseQueryResult<
  VersionCheck,
  unknown
> => {
  const url = siteSettings.siteApiURL;

  return useQuery({
    queryKey: ["settings/versioncheck"],
    queryFn: async () => {
      const { data } = await axios.get<VersionCheck>(
        // prettier-ignore
        `${url}/settings/versioncheck?v=${siteSettings.frontEndVersion}&rnd=${Math.random()}`
      );

      return data;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity
  });
};
